// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"c049b531","453":"bd30ca5a","455":"5b4349d1","977":"aa7ae977"}[chunkId] + ".chunk.js";
};